/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type RiskMitigationTabEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const riskMitigationTabEntryPoint: EntryPoint<RiskMitigationTabEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<RiskMitigationTabEntryPointComponent>(
			/* webpackChunkName: "async-prevention-center-risk-mitigation-tab" */ './RiskMitigationTab.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
